// src/components/NotFound/NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";
import conf from "../conf/conf";

export default function NotFound() {
  const { whatsapp_url, telegram_url, linkedin_url } = conf;

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-12 flex justify-center relative mt-16">
      {/* Main 404 Content */}
      <div className="bg-white p-12 rounded-3xl shadow-xl text-center max-w-xl">
        <h1 className="text-6xl font-extrabold text-red-600 mb-4">404</h1>
        <p className="text-2xl font-semibold mb-6">This page doesn't exist</p>
        <p className="mb-6 text-gray-700">
          The URL you entered may be incorrect or the page has been removed.
        </p>

        {/* Contact Section */}
        <p className="mb-4 font-semibold text-gray-800">Contact us for help:</p>
        <div className="flex justify-center gap-4 flex-wrap mb-8">
          <a
            href={whatsapp_url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-green-500 text-white px-5 py-2 rounded-full shadow-md hover:bg-green-600 transition"
          >
            <FaWhatsapp className="text-xl" />
            WhatsApp
          </a>

          <a
            href={telegram_url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-sky-500 text-white px-5 py-2 rounded-full shadow-md hover:bg-sky-600 transition"
          >
            <FaTelegramPlane className="text-xl" />
            Telegram
          </a>

          <a
            href={linkedin_url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-blue-700 text-white px-5 py-2 rounded-full shadow-md hover:bg-blue-800 transition"
          >
            <FaLinkedin className="text-xl" />
            LinkedIn
          </a>
        </div>

        {/* Jobs CTA */}
        <div className="mt-10 bg-indigo-50 border border-indigo-200 rounded-2xl p-6 shadow-sm">
          <p className="text-lg font-semibold text-indigo-700 mb-4">
            🚀 Looking for job opportunities?
          </p>
          <Link
            to="/"
            className="inline-block bg-indigo-600 text-white px-8 py-3 rounded-full shadow-lg hover:bg-indigo-700 hover:shadow-xl transition-all font-semibold text-base"
          >
            Explore Jobs
          </Link>
        </div>
      </div>

      {/* Right Sidebar Ad (Visible on large screens)
      <div className="hidden lg:flex lg:ml-8 lg:col-span-3 justify-center">
        <div className="sticky top-32 h-[600px] w-[300px]">
          <AdCard
            size="large"
            className="h-full w-full rounded-xl shadow-lg bg-gradient-to-b from-green-400 to-teal-500 text-white"
          />
        </div>
      </div> */}
    </div>
  );
}
